<div class="success-container">
  <div class="success-card">
    <div class="success-icon">
      <span class="checkmark">✓</span>
    </div>

    <div class="success-message">
      <h2>Check-in Successful!</h2>
      <p>You have been checked in successfully.</p>
    </div>

    <div class="redirect-message">
      <p>Returning to check-in screen in <span class="countdown">{{secondsLeft}}</span> seconds</p>
    </div>

    <app-button
      (onClick)="goBackToCheckin()"
      size="large"
      class="back-button"
    >
      Back to Check-in
    </app-button>
  </div>
</div>
